import { action, computed, makeObservable, observable } from "mobx";
import { RootStore } from "src/stores/RootStore";

export enum AGENDA_VOTING_PROCESS {
    START_AGENDA_VOTING,
    AGENDA_VOTING_OPTIONS
}

export enum AGENDA_VOTING_PROCESS_STEP {
    START_AGENDA_VOTING,
    AGENDA_VOTING_OPTIONS
}

interface IProcessStep {
    stepNumber: number;
    stepType: AGENDA_VOTING_PROCESS_STEP;
    next?: () => IProcessStep | null;
    prev?: () => IProcessStep | null;
    parent: IProcess | null;
}

interface IProcess {
    type: AGENDA_VOTING_PROCESS;
    processSteps: IProcessStep[];
}

interface IAgendaVotingProcess {
    stepNumber: number;
    stepType: AGENDA_VOTING_PROCESS_STEP;
    processes: IProcess[];
}

export class AgendaVotingProgressModalStore {
    rootStore: RootStore;

    currentProcessType: AGENDA_VOTING_PROCESS = AGENDA_VOTING_PROCESS.START_AGENDA_VOTING;
    currentStepType: AGENDA_VOTING_PROCESS_STEP = AGENDA_VOTING_PROCESS_STEP.START_AGENDA_VOTING;
    VOTING_MODAL_MAX_NUMBER_OF_STEPS = 2;

    agendaVotingProcess: IAgendaVotingProcess = {
        stepNumber: 1,
        stepType: AGENDA_VOTING_PROCESS_STEP.START_AGENDA_VOTING,
        processes: [
            {
                type: AGENDA_VOTING_PROCESS.START_AGENDA_VOTING,
                processSteps: [
                    {
                        stepNumber: 1,
                        stepType: AGENDA_VOTING_PROCESS_STEP.START_AGENDA_VOTING,
                        next: function () {
                            return this.parent ? this.parent.processSteps[0] : null;
                        },
                        prev: function () {
                            return null;
                        },
                        parent: null
                    }
                ]
            },
            {
                type: AGENDA_VOTING_PROCESS.AGENDA_VOTING_OPTIONS,
                processSteps: [
                    {
                        stepNumber: 2,
                        stepType: AGENDA_VOTING_PROCESS_STEP.AGENDA_VOTING_OPTIONS,
                        next: function () {
                            return null;
                        },
                        prev: function () {
                            return null;
                        },
                        parent: null
                    }
                ]
            }
        ]
    };

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        // Assign parents post object creation
        for (let process of this.agendaVotingProcess.processes) {
            for (let step of process.processSteps) {
                step.parent = process;
            }
        }

        makeObservable(this, {
            currentProcessType: observable,
            currentStepType: observable,

            getProcess: action,
            resetCurrentProcessType: action,
            setCurrentProcessType: action,
            setCurrentStepType: action,

            processes: computed,
            currentProcess: computed,
            currentStep: computed
        });
    }

    getProcess = (processType: AGENDA_VOTING_PROCESS) => {
        return this.agendaVotingProcess.processes.find((process) => {
            return process.type === processType;
        })!;
    };

    resetCurrentProcessType() {
        this.currentProcessType = AGENDA_VOTING_PROCESS.START_AGENDA_VOTING;
        this.currentStepType = AGENDA_VOTING_PROCESS_STEP.START_AGENDA_VOTING;
    }

    setCurrentProcessType = (processType: AGENDA_VOTING_PROCESS) => {
        this.currentProcessType = processType;
        this.currentStepType = this.getProcess(processType).processSteps[0].stepType;
    };

    setCurrentStepType = (stepType: AGENDA_VOTING_PROCESS_STEP) => {
        this.currentStepType = stepType;
    };

    /* COMPUTED */
    get processes() {
        return this.agendaVotingProcess.processes;
    }

    get currentProcess(): IProcess | undefined {
        return this.agendaVotingProcess.processes.find((process) => process.type === this.currentProcessType);
    }

    get currentStep(): IProcessStep | undefined {
        return this.currentProcess?.processSteps.find((step) => step.stepType === this.currentStepType);
    }
}
